import { useState } from "react"
import { PhotoCaptureModal } from "./PhotoCaptureModal"
import { PhotoConfirmModal } from "./PhotoConfirmModal"

interface KeyRotationPhotoModalProps {
    isOpen: boolean
    onClose: () => void
    onConfirm: (photoFile: File) => void
}

export const KeyRotationPhotoModal = ({
    isOpen,
    onClose,
    onConfirm
}: KeyRotationPhotoModalProps) => {
    const [photoFile, setPhotoFile] = useState<File | null>(null)
    const [showConfirmation, setShowConfirmation] = useState(false)

    const handlePhotoCapture = (file: File) => {
        setPhotoFile(file)
        setShowConfirmation(true)
    }

    const handleConfirm = () => {
        if (photoFile) {
            onConfirm(photoFile)
            handleClose()
        }
    }

    const handleRetake = () => {
        setPhotoFile(null)
        setShowConfirmation(false)
    }

    const handleClose = () => {
        setPhotoFile(null)
        setShowConfirmation(false)
        onClose()
    }

    return (
        <>
            <PhotoCaptureModal
                isOpen={isOpen && !showConfirmation}
                onClose={handleClose}
                onPhotoCapture={handlePhotoCapture}
            />
            <PhotoConfirmModal
                isOpen={isOpen && showConfirmation}
                photoFile={photoFile}
                onConfirm={handleConfirm}
                onRetake={handleRetake}
            />
        </>
    )
}
